<template>
  <Loader v-if="loader" />

  <div class="card">
    <div class="grid">
      <div class="col-12 lg:col-3">
          <h6 class="ml-2">Data valuta</h6>
          <Calendar v-model="selectedDates" selectionMode="range" :showIcon="true" dateFormat="dd-mm-yy" class="inputfield w-full mt-2"/>
          <div v-show="validationErrors.dates && submitted" class="p-error">Seleziona campo.</div>
      </div>
      <div class="col-12 lg:col-3 flex align-items-end">
        <Checkbox v-model="excludeRidAndCompensation" :binary="true" />
        <h6 class="m-0 ml-2"> Escludi Rid/Compensazioni </h6>
      </div>
      <div class="col-12 lg:col-3 flex align-items-end">
        <Checkbox v-model="excludeOut" :binary="true" />
        <h6 class="m-0 ml-2"> Escludi uscite </h6>
      </div>
      <div class="col-12 lg:col-3 flex align-items-end justify-content-right">
        <Button label="Cerca" @click="searchData" icon="pi pi-search" iconPos="left" class="w-full" />
        <Button label="Esporta" @click="exportAllData" icon="pi pi-download" class="w-full ml-2 p-button-secondary" />
      </div>
    </div>
  </div>

<div class="card">
  <DataTable :value="items" responsiveLayout="scroll">
    <template #empty>
        <div class="text-center">Nessun dato trovato.</div>
    </template>
    <Column field="agente" header="Agente" :sortable="true"></Column>
    <Column field="total_paid" header="Totale Pagamenti" :sortable="true">
      <template #body="{data}">
        {{formatCurrency(data.total_paid)}}
      </template>
    </Column>
    <Column header="Dettagli" class="border-lt">
      <template #body="{data, index}">
        <Button v-if="data.details.length > 0" label="Dettagli"  class="p-button-text" @click="showDetailsPayments(index)" />
      </template>
    </Column>
    <Column field="email" header="Invia a" class="border-lt" >
      <template #body="{data}">
        <div class="grid">
          <div class="col-10">
             <InputText v-model="data.email" class="w-full"/>
          </div>
          <div class="col-2">
              <Button @click="sendEmailSummary(data)" icon="pi pi-send" class="p-button-rounded p-button-primary" />
          </div>
          
        </div>
      </template>
    </Column>
    <ColumnGroup type="footer">
      <Row>
        <Column :colspan="1" class="td-footer" footer="Totali"/>
        <Column :colspan="1" class="td-footer" :footer="totale_pagamenti()" />
        <Column :colspan="1" class="td-footer"/>
        <Column :colspan="1" class="td-footer"/>
      </Row>
    </ColumnGroup>
  </DataTable>
</div>

  <Dialog v-model:visible="detailsDialog" :style="{width: '85vw'}" header="Dettagli" :modal="true" >
      <div>
        <DataTable ref="dt" :value="sortedDetailsPayments" responsiveLayout="scroll" dataKey="numero" :paginator="true" :rows="20"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[10,20,50]" 
          currentPageReportTemplate="{first} a {last} di {totalRecords}" :filters="filters">
          <template #header>
            <div class="flex justify-content-between flex-wrap">
                <div class="flex align-items-center justify-content-center mb-2">
                  <span class="p-input-icon-left">
                      <i class="pi pi-search" />
                      <InputText type="search" v-model="filters['global'].value" placeholder="Cerca..." />
                  </span>
                </div>
                <div class="flex align-items-center justify-content-center">
                  <Button icon="pi pi-download" label="Esporta" @click="exportCSV" class="p-button-secondary" />
                </div>
            </div>
          </template>
          <template #empty>
              <div class="text-center">Nessun dato trovato.</div>
          </template>
          <Column field="cliente" header="Cliente" />
          <!-- for export -->
          <Column field="pod" header="Pod" style="display:none"> 
            <template #body="{data}">
              {{data.pod}}
            </template>
          </Column>
          <Column field="pdr" header="Pdr" style="display:none">
            <template #body="{data}">
              {{data.pdr}}
            </template>
          </Column>
          <!-- for export -->
          <Column header="Fornitura" >
            <template #body="{data}">
              {{data.pod ?? data.pdr}}
            </template>
          </Column>
          <Column field="numero" header="Numero" />
          <Column field="paid" header="Pagato" >
            <template #body="{data}">
              {{formatCurrency(data.paid)}}
            </template>
          </Column>
          <Column field="tipo_pagamento" header="Tipo Pagamento" />
          <Column field="rappresentante" header="Rappresentante" />
          <Column field="note" header="Note" />
          <Column field="data_insert" header="Data Inserimento" >
            <template #body="{data}">
              {{formatDate(data.data_insert)}}
            </template>
          </Column>
        </DataTable>
      </div>
      <template #footer>
          <Button label="Chiudi" icon="pi pi-times" class="p-button-text" @click="detailsDialog = false"/>
      </template>
  </Dialog>
</template>

<script>
import moment from 'moment'
import Service from '@/services/ask-pratiche/pratiche-service'
import { ref, onMounted, computed, getCurrentInstance  } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import Loader from '@/components/Loader.vue'
import { useToast } from "primevue/usetoast";


export default {
    components: {
      Loader
    },
    setup() {
      
      const dt = ref();
      const regex_email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      const toast = useToast();
      const filters = ref({
          'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      });
      const self = getCurrentInstance();
      self.$eventBus = self.appContext.config.globalProperties.$eventBus
      self.$http = self.appContext.config.globalProperties.$http
      const service = new Service(self.$http, self.$eventBus)
      const formatDate = self.appContext.config.globalProperties.$formatDate
      const loader = ref(false)
      const items = ref([])
      const selectedDates = ref([new Date()])
      const detailsPayments = ref([])
      const detailsDialog = ref(false)
      const excludeRidAndCompensation = ref(true)
      const excludeOut = ref(true)
      const validationErrors = ref({})
      const submitted = ref(false)

      onMounted(() => { 
        searchData()
      })

       const searchData = () => {
        submitted.value = true;
        if (validateInputs()) {
          loader.value = true
          items.value = []
          let dates = []
          if (selectedDates.value[0]) {
            dates[0] = moment(selectedDates.value[0]).format('YYYY-MM-DD');
            let index = selectedDates.value.length > 1 && selectedDates.value[1] != null ? 1 : 0
            dates[1] = moment(selectedDates.value[index]).format('YYYY-MM-DD');
          }
          // if (selectedDates.value[1]) {
          //   dates[1] = moment(selectedDates.value[1]).format('YYYY-MM-DD');
          // }
          
          service.getSummaryPayments(dates, excludeRidAndCompensation.value, excludeOut.value)
          .then((res) => {
            items.value = res.items
          }).finally(() => {
              loader.value = false
          })
        }
      }

      const showDetailsPayments = (index) => {
        // console.log(items.value[index].details);
        detailsDialog.value = true
        detailsPayments.value = items.value[index].details;
      }

      const sortedDetailsPayments = computed(() => {
        return detailsPayments.value.slice().sort((a, b) => {
          if (a.rappresentante < b.rappresentante) return -1;
          if (a.rappresentante > b.rappresentante) return 1;
          return 0;
        });
      });
      
      const totale_pagamenti = () => {
        let total = 0;
        items.value.forEach(els => {
          els.details.forEach(el => {
            total += el.paid;
          });
          
        });
        return formatCurrency(total);
      }

      const sendEmailSummary = (data) => {
        if (regex_email.test(data.email)) {
          loader.value = true
          service.sendSummaryPayments(data)
          .then((res) => {
            if (res.item) {
              toast.add({severity:'success', summary: 'Successo', detail:'Email inviata'});
            } else {
              toast.add({severity:'warn', summary: 'Errore', detail:'Email non inviata'});
            }
          }).finally(() => {
              loader.value = false
          })
        } else {
          toast.add({severity:'warn', summary: 'Attenzione', detail:'Formato email non valido'});
        }
      }

      const validateInputs = () =>{
        validationErrors.value = {}

        if (selectedDates.value == null)
          validationErrors.value['dates'] = true;
        else 
          delete validationErrors.value['dates'];

    
        return !Object.keys(validationErrors.value).length;
      }

      const formatCurrency = (value) => {
        return value.toLocaleString('it-IT', {style: 'currency', currency: 'EUR'});
      };

      const exportAllData = () => {
    if (items.value.length > 0) {
        let csvContent = "data:text/csv;charset=utf-8,";

        items.value.forEach(item => {
            
            csvContent += `Agente: ${item.agente}\n`;
            
            csvContent += "Cliente,Fornitura,Numero,Pagato,Tipo Pagamento,Rappresentante,Note,Data Inserimento\n";

            item.details.forEach(detail => {
                const paidValue = detail.paid != null ? formatCurrency(detail.paid) : "N/A";  
                const fornitura = detail.pod ?? detail.pdr;
                const dataInserimento = detail.data_insert != null ? formatDate(detail.data_insert) : "N/A";  

                csvContent += `${detail.cliente},${fornitura},${detail.numero},${paidValue},${detail.tipo_pagamento},${detail.rappresentante},${detail.note},${dataInserimento}\n`;
            });
            
          
            csvContent += "\n";
        });

        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "summary_payments_details.csv");
        document.body.appendChild(link);

        link.click(); 
    } else {
        toast.add({severity:'warn', summary: 'Attenzione', detail:'Nessun dato disponibile per l\'esportazione'});
    }
};


      const exportCSV = () => {
        dt.value.exportCSV()
      };

      return {
        dt,
        formatDate,
        moment,
        items,
        loader, 
        filters, 
        selectedDates,
        searchData,
        showDetailsPayments,
        sortedDetailsPayments,
        detailsPayments,
        detailsDialog,
        totale_pagamenti,
        excludeRidAndCompensation,
        excludeOut,
        sendEmailSummary,
        formatCurrency,
        validationErrors,
        submitted,
        exportCSV,
        exportAllData
      }
  }
}
</script>
